import {
  SET_ALL_PARENT_CHILD_OPTIONS,
  SET_PARENT_CHILD_ERROR,
  SET_PARENT_CHILD_IS_LOADING,
  SET_POS_MENUS,
  SET_CUBOH_MENU_ITEMS,
  SET_SINGLE_MENU,
  SET_IS_LOADING,
  SET_ERROR,
  UPDATE_CUBOH_MENU_ITEM,
  MENU_OBJECT_TYPES,
  SET_DEFAULT_STATE,
  UPDATE_MENU_INTEGRATION,
  SET_MERCHANT_INTEGRATIONS,
  SET_INTEGRATIONS_IS_LOADING,
  SET_INTEGRATIONS_ERROR,
  SET_ALL_SUPPORTED_INTEGRATIONS,
  SET_SUPPORTED_IS_LOADING,
  SET_SUPPORTED_ERROR,
  SET_AVAILABLE_CLASSIFICATIONS,
  SET_CLASSIFICATIONS_IS_LOADING,
  SET_CLASSIFICATIONS_ERROR,
} from 'constants/menuManagement';

export const DEFAULT_STATE = {
  singleMenu: {
    [MENU_OBJECT_TYPES.single]: {
      data: {},
      isLoading: false,
      error: {
        hasError: false,
        message: null,
      },
    },
  },
  cubohMenus: {
    [MENU_OBJECT_TYPES.menus]: {
      data: {},
      isLoading: false,
      error: {
        hasError: false,
        message: null,
      },
    },
    [MENU_OBJECT_TYPES.categories]: {
      data: {},
      isLoading: false,
      error: {
        hasError: false,
        message: null,
      },
    },
    [MENU_OBJECT_TYPES.items]: {
      data: {},
      isLoading: false,
      error: {
        hasError: false,
        message: null,
      },
    },
    [MENU_OBJECT_TYPES.modifierGroups]: {
      data: {},
      isLoading: false,
      error: {
        hasError: false,
        message: null,
      },
    },
    [MENU_OBJECT_TYPES.modifiers]: {
      data: {},
      isLoading: false,
      error: {
        hasError: false,
        message: null,
      },
    },
  },
  posMenus: {
    menus: {},
    categories: {},
    items: {},
    modifierGroups: {},
    modifiers: {},
    isLoading: false,
    error: {
      hasError: false,
      message: null,
    },
  },
  // the properties of the resource will change depending on the type (squareapp vs auphan etc..)
  resource: {
    posSystem: null,
    isLoading: false,
    error: {
      hasError: false,
      message: null,
    },
  },
};

export const reducer = (state, action) => {
  switch (action.type) {
    case SET_SINGLE_MENU:
      return {
        ...state,
        singleMenu: {
          ...state.singleMenu,
          [action.itemType]: {
            ...state.singleMenu[action.itemType],
            data: {
              ...state.singleMenu[action.itemType]?.data,
              ...action.data,
            },
          },
        },
      };
      case SET_CUBOH_MENU_ITEMS: {
        let newState;

        if (action.group === MENU_OBJECT_TYPES.menus) {
          const merchantId = Object.keys(action.data)[0];

          // Removes any null values from deleting menus before a new menu is created
          const currentMerchantGroupData =
            state.cubohMenus[action.group]?.data[merchantId]?.filter(menu => menu) ?? [];

          const updatedData = {
            ...state.cubohMenus[action.group]?.data,
            [merchantId]: action.itemType === 'menu_ordinal'
              ? action.data[merchantId]
              : [...currentMerchantGroupData, ...action.data[merchantId]],
          };

          newState = {
            ...state,
            cubohMenus: {
              ...state.cubohMenus,
              [action.group]: {
                ...state.cubohMenus[action.group],
                data: updatedData,
              },
            },
          };
        } else {
          newState = {
            ...state,
            cubohMenus: {
              ...state.cubohMenus,
              [action.itemType]: {
                ...state.cubohMenus[action.itemType],
                data: {
                  ...state.cubohMenus[action.itemType]?.data,
                  ...action.data,
                },
              },
            },
          };
        }

        return newState;
      }

    case UPDATE_CUBOH_MENU_ITEM:
      if (action.group === MENU_OBJECT_TYPES.menus) {
        const currentMenus = state.cubohMenus[action.group]?.data[action.data.merchantId] ?? [];

        const currentIndex = currentMenus.map(menu => menu?.uuid).indexOf(action.id);

        if (action.data.isDeleted) {
          delete currentMenus[currentIndex];
        } else {
          currentMenus[currentIndex] = action.data;
        }
        return {
          ...state,
          cubohMenus: {
            ...state.cubohMenus,
            [action.group]: {
              ...state.cubohMenus[action.group],
              data: {
                ...state.cubohMenus[action.group]?.data,
                [action.data.merchantId]: currentMenus,
              },
            },
          },
        };
      }

      if (action.data.isDeleted) {
        const updatedData = state.cubohMenus[action.group].data;
        delete updatedData[action.id];
        return {
          ...state,
          cubohMenus: {
            ...state.cubohMenus,
            [action.group]: {
              ...state.cubohMenus[action.group],
              data: {
                ...updatedData,
              },
            },
          },
        };
      }
      return {
        ...state,
        cubohMenus: {
          ...state.cubohMenus,
          [action.group]: {
            ...state.cubohMenus[action.group],
            data: {
              ...state.cubohMenus[action.group]?.data,
              [action.id]: action.data,
            },
          },
        },
      };
    case UPDATE_MENU_INTEGRATION:
      return {
        ...state,
        cubohMenus: {
          ...state.cubohMenus,
          cuboh_menu: {
            ...state.cubohMenus.cuboh_menu,
            data: {
              ...state.cubohMenus.cuboh_menu.data,
              [action.id]: {
                ...state.cubohMenus.cuboh_menu.data[action.id],
                integrations: action.data,
              },
            },
          },
        },
      };
    case SET_POS_MENUS:
      return {
        ...state,
        posMenus: { ...state.posMenus, menus: [...action.menus] },
      };
    case SET_ALL_PARENT_CHILD_OPTIONS:
      return {
        ...state,
        allParentChildOptions: {
          [action.menuId]: action.allParentChildOptions,
        },
      };
    case SET_PARENT_CHILD_IS_LOADING:
      return {
        ...state,
        parentChildIsLoading: { [action.menuId]: action.isLoading },
      };
    case SET_PARENT_CHILD_ERROR:
      return {
        ...state,
        parentChildError: {
          [action.menuId]: {
            hasError: action.hasError,
            message: action.error,
          },
        },
      };
    case SET_MERCHANT_INTEGRATIONS:
      return {
        ...state,
        merchantIntegrations: {
          ...state.merchantIntegrations,
          [action.merchantId]: action.merchantIntegrations,
        },
      };
    case SET_INTEGRATIONS_IS_LOADING:
      return {
        ...state,
        merchantIntegrationsIsLoading: {
          [action.merchantId]: action.isLoading,
        },
      };
    case SET_INTEGRATIONS_ERROR:
      return {
        ...state,
        merchantIntegrationsError: {
          [action.merchantId]: {
            hasError: action.hasError,
            message: action.error,
          },
        },
      };
    case SET_ALL_SUPPORTED_INTEGRATIONS:
      return {
        ...state,
        supportedIntegrations: action.supportedIntegrations,
      };
    case SET_SUPPORTED_IS_LOADING:
      return {
        ...state,
        supportedIntegrationsIsLoading: action.isLoading,
      };
    case SET_SUPPORTED_ERROR:
      return {
        ...state,
        supportedIntegrationsError: {
          hasError: action.hasError,
          message: action.error,
        },
      };
    case SET_AVAILABLE_CLASSIFICATIONS:
      return {
        ...state,
        availableClassifications: action.availableClassifications,
      };
    case SET_CLASSIFICATIONS_IS_LOADING:
      return {
        ...state,
        classificationsIsLoading: action.isLoading,
      };
    case SET_CLASSIFICATIONS_ERROR:
      return {
        ...state,
        classificationsError: {
          hasError: action.hasError,
          message: action.error,
        },
      };
    case SET_IS_LOADING:
      return {
        ...state,
        [action.parentGroup]: {
          ...state[action.parentGroup],
          [action.group]: {
            ...state[action.parentGroup][action.group],
            isLoading: action.isLoading,
          },
        },
      };
    case SET_ERROR:
      return {
        ...state,
        [action.parentGroup]: {
          ...state[action.parentGroup],
          [action.group]: {
            ...state[action.parentGroup][action.group],
            error: { hasError: action.hasError, message: action.message },
          },
        },
      };
    case SET_DEFAULT_STATE:
      return DEFAULT_STATE;
    default:
      return { ...state };
  }
};
